import { render, staticRenderFns } from "./OrganizationEditor.vue?vue&type=template&id=79c7bf0e&"
import script from "./OrganizationEditor.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports